// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import AddressSharedStyles from "@synd/App/SharedStyles/xAddressStyles";

addressInfoDisplayStyles.wrapper = {
    ...AddressSharedStyles.address.wrapper,
};

addressInfoDisplayStyles.address1Text = {
    ...AddressSharedStyles.address.address1Text,
};

addressInfoDisplayStyles.address2Text = {
    ...AddressSharedStyles.address.address2Text,
};

addressInfoDisplayStyles.address3Text = {
    ...AddressSharedStyles.address.address3Text,
};

addressInfoDisplayStyles.address4Text = {
    ...AddressSharedStyles.address.address4Text,
};

addressInfoDisplayStyles.attentionText = {
    ...AddressSharedStyles.address.attentionText,
};
addressInfoDisplayStyles.cityStatePostalCodeText = {
    ...AddressSharedStyles.address.cityStatePostalCodeText,
};
addressInfoDisplayStyles.cityText = {
    ...AddressSharedStyles.address.cityText,
};

addressInfoDisplayStyles.stateText = {
    ...AddressSharedStyles.address.stateText,
};

addressInfoDisplayStyles.postalCodeText = {
    ...AddressSharedStyles.address.postalCodeText,
};

addressInfoDisplayStyles.companyNameText = {
    ...AddressSharedStyles.address.companyNameText,
};

addressInfoDisplayStyles.countryText = {
    ...AddressSharedStyles.address.countryText,
};

addressInfoDisplayStyles.emailText = {
    ...AddressSharedStyles.address.emailText,
};

addressInfoDisplayStyles.phoneText = {
    ...AddressSharedStyles.address.phoneText,
};

addressInfoDisplayStyles.faxText = {
    ...AddressSharedStyles.address.faxText,
};

addressInfoDisplayStyles.firstNameText = {
    ...AddressSharedStyles.address.firstNameText,
};

addressInfoDisplayStyles.lastNameText = {
    ...AddressSharedStyles.address.lastNameText,
};

addressInfoDisplayStyles.customerNameText = {
    ...AddressSharedStyles.address.customerNameText,
};
